import { Divider, Typography } from "@suraasa/placebo-ui"
import { Assignments, Classes } from "api/resources/analytics/types"
import { DeliveryMode } from "api/resources/learningItems/types"

interface AssignmentsAnalyticsProps {
  assignments: Assignments | undefined
  classes: {
    liveClasses: Classes | undefined
    recordedClasses: Classes | undefined
  }
  deliveryMode: DeliveryMode
}

const AssignmentsAnalytics = ({
  assignments,
  classes: { liveClasses, recordedClasses },
  deliveryMode,
}: AssignmentsAnalyticsProps) => {
  const showLive = deliveryMode !== DeliveryMode.PROFESSIONAL
  const showRecorded = deliveryMode !== DeliveryMode.LIVE_INSTRUCTOR_LED

  const total = assignments?.total ?? 0
  const completed = assignments?.completed ?? 0
  const overdue = assignments?.overdue ?? 0
  const due = Math.max(total - completed - overdue, 0)

  return (
    <>
      <div className="p-2.5">
        <Typography className="mb-3 text-muted" variant="strongSmallBody">
          Assignments
        </Typography>
        <div className="flex gap-x-4.5">
          <div className="flex flex-col gap-1">
            <Typography variant="smallBody" className="text-muted">
              Due
            </Typography>
            <Typography variant="title2" className="text-onSurface-900">
              {due}
            </Typography>
          </div>
          <div className="flex flex-col gap-1">
            <Typography variant="smallBody" className="text-muted">
              Missed
            </Typography>
            <Typography variant="title2" className="text-onSurface-900">
              {overdue}
            </Typography>
          </div>
          <div className="flex flex-col gap-1">
            <Typography variant="smallBody" className="text-muted">
              Completed
            </Typography>
            <Typography variant="title2" className="text-onSurface-900">
              {completed}
            </Typography>
          </div>
        </div>
      </div>

      {deliveryMode !== DeliveryMode.STARTER && (
        <>
          <Divider className="bg-onSurface-200" />
          <div className="p-2.5">
            <Typography className="mb-3 text-muted" variant="strongSmallBody">
              Classes Attended
            </Typography>
            <div className="flex gap-x-4.5">
              {showLive && (
                <div className="flex flex-col gap-1">
                  <Typography
                    variant="smallBody"
                    className="text-onSurface-600"
                  >
                    Live
                  </Typography>
                  <Typography variant="title2" className="text-onSurface-900">
                    {liveClasses?.completed ?? 0}
                    <span className="text-strong text-onSurface-400">
                      {" "}
                      / {liveClasses?.total ?? 0}
                    </span>
                    {!showRecorded && (
                      <span className="text-strong text-onSurface-400">
                        {" "}
                        attended
                      </span>
                    )}
                  </Typography>
                </div>
              )}
              {showRecorded && (
                <div className="flex flex-col gap-1">
                  <Typography
                    variant="smallBody"
                    className="text-onSurface-600"
                  >
                    Recorded
                  </Typography>
                  <Typography variant="title2" className="text-onSurface-900">
                    {recordedClasses?.completed ?? 0}
                    <span className="text-strong text-onSurface-400">
                      {" "}
                      / {recordedClasses?.total ?? 0}
                    </span>
                    {!showLive && (
                      <span className="text-strong text-onSurface-400">
                        {" "}
                        attended
                      </span>
                    )}
                  </Typography>
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </>
  )
}

export default AssignmentsAnalytics
